import React, { useRef, useEffect } from 'react';

import { RefreshIcon, CameraSwitchIcon } from 'src/assets/images';
import { LoaderAnimation } from 'src/components';
import { CustomerTypes } from 'src/context/salesforce-context';
import ImageCapture, {
  ImageCaptureResolutionHint,
  ImageMirrorBehavior,
  RenderProps,
  ResolutionOptionType,
} from '../image-capture/image-capture';
import './image-capture-modal.scss';

export default function ImageCaptureModal(props) {
  const topOfPage = useRef('top');

  useEffect(() => {
    if (props.show) {
      if (topOfPage.current) {
        // @ts-ignore
        topOfPage.current.scrollIntoView(true);
      }
    }
  }, [props.show]);

  const modalBottom = (isMobile = false, renderProps) => (
    <>
      <p className={`selfie-text has-padding-bottom-6 ${isMobile ? '' : 'has-padding-top-3'}`}>
        {props.customerType === CustomerTypes.normal || props.customerType === CustomerTypes.pos
          ? 'Position your face in the circle and take your photo'
          : "Position the customer's face in the circle and take the photo"}
      </p>
      <div>
        <button
          className="refresh-button"
          disabled={renderProps.status.isRefreshingDeviceList}
          onClick={() => {
            renderProps.commands.refreshDeviceList();
            props.refreshTagging();
          }}
        >
          {renderProps.status.isRefreshingDeviceList ? (
            <LoaderAnimation height={30} width={30} />
          ) : (
            <img src={RefreshIcon} />
          )}
        </button>
        <button
          disabled={renderProps.status.isDeviceLoading}
          className="button take-photo-button"
          onClick={() => {
            renderProps.commands.captureImage();
          }}
          automationid={`${props.automationIdPrefix}_Anchor_Capture_Button`}
        >
          Take photo
        </button>
        {renderProps.status.devicesTotalCount > 1 && (
          <button
            className="switch-camera-button"
            onClick={() => {
              renderProps.commands.switchDevice();
              props.switchTagging();
            }}
          >
            <img src={CameraSwitchIcon} />
          </button>
        )}
      </div>
    </>
  );

  return (
    <ImageCapture
      imageDisplayResolution={{
        height: 480,
        width: 640,
      }}
      imageCaptureResolutionHint={{ type: ResolutionOptionType.AUTO } as ImageCaptureResolutionHint}
      onImageCaptured={(base64Image: string) => {
        props.onImageCapture(base64Image);
        props.onHide();
      }}
      imageMirrorBehavior={ImageMirrorBehavior.FLIP_WHEN_USER_FACING}
    >
      {(renderProps: RenderProps) => {
        return (
          <div
            className={`ImageCaptureModal modal ${props.show ? 'is-active' : ''}`}
            automationid={`${props.automationIdPrefix}_ImageCaptureModal_Main`}
          >
            <div className="modal-background" />
            <div className="modal-container">
              <div className="webcam-container">
                <span /** @ts-ignore **/
                  ref={topOfPage}
                  className="close-button"
                  disabled={props.disabled}
                  onClick={() => {
                    if (!props.disabled) {
                      props.onHide();
                    }
                  }}
                  automationid={`${props.automationIdPrefix}_Span_Close_Modal_Button`}
                />
                <div className="webcam-loader">
                  <LoaderAnimation />
                </div>

                <div className="webcam-component">
                  {renderProps.renderFunctions.drawCameraDisplay()}
                </div>

                <div className="modal-bottom is-hidden-touch is-hidden-tablet-only">
                  {modalBottom(false, renderProps)}
                </div>
              </div>
              <div className="modal-bottom-mobile is-hidden-desktop">
                {modalBottom(true, renderProps)}
              </div>
            </div>
          </div>
        );
      }}
    </ImageCapture>
  );
}
